import { UserRepo, CreateUserData } from "../domain/UserRepo";

export interface CreateUserScreenData {
  ui_loading: boolean;
  error_message: string;
  success_message: string;
}

export interface CreateUserResult {
  success: boolean;
  user_id?: number;
}

export class CreateUserCommand {
  constructor(
    private userRepo: UserRepo,
    private screenData: CreateUserScreenData
  ) {}

  async execute(userData: CreateUserData): Promise<CreateUserResult> {
    this.screenData.ui_loading = true;
    this.screenData.error_message = '';
    this.screenData.success_message = '';

    try {
      const result = await this.userRepo.create(userData);

      if (result.error) {
        this.screenData.error_message = result.error;
        return { success: false };
      }

      this.screenData.success_message = 'Usuario creado con éxito';
      return {
        success: true,
        user_id: result.user_id
      };
    } catch (error: any) {
      this.screenData.error_message = error.message || 'Error al crear usuario';
      return { success: false };
    } finally {
      this.screenData.ui_loading = false;
    }
  }
}
